import React, { useEffect } from 'react'
import * as S from '../style'
import SelectHeatNumberInCertificate from '../../../../../components/Certificates/SelectItem/HeatNumber'
import SelectMaterialInCertificate from '../../../../../components/Certificates/SelectItem/Material'
import SelectProductionOrderInCertificate from '../../../../../components/Certificates/SelectItem/ProductionOrder'
import { CertificateType } from '..'
import { Input } from '../../../../../components/styles/select-style'
import { Textarea } from '../../../../../components/styles/modal-style'

interface PropsType {
  certificate: CertificateType
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>
}

const HeaderFields:React.FC<PropsType> = ({certificate, setCertificate}) => {
  const itsOurs = certificate.supplier?.isMain === true

  useEffect(() => {
    if(certificate.supplier.isMain) {
      setCertificate(() => ({
        ...certificate,
        observations: `Garantimos que o grau de redução do(s) forjado(s) e laminado(s) é de ao menos 3:1.

Assumimos a responsabilidade pela veracidade das informações acima, que refletem fielmente os dados originais fornecidos pelo fabricante
        `
      }))
    }
  }, [certificate.supplier.id])
  
  return (
    <S.StructureContainer>
      <S.HeaderFieldsContainer>
        <SelectHeatNumberInCertificate certificate={certificate} setCertificate={setCertificate} itsOurs={itsOurs} />
        <SelectMaterialInCertificate certificate={certificate} setCertificate={setCertificate} itsOurs={!itsOurs} />
        <S.InputDiv>
          <S.Label>Descrição</S.Label>
          <Input 
            placeholder='Digite aqui'
            value={certificate.description || ''}
            onChange={(e) => setCertificate(prev => ({...prev, description:e.target.value}))}
          />
          </S.InputDiv>
        <S.InputDiv>
          <S.Label>Nota fiscal</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.invoiceNumber || ''}
            onChange={(e) => setCertificate(prev => ({...prev, invoiceNumber:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Norma</S.Label>
          <Input 
            placeholder='Digite aqui'
            value={certificate.standard || ''}
            onChange={(e) => setCertificate(prev => ({...prev, standard:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Tratamento térmico</S.Label>
          <Input 
            placeholder='Digite aqui'
            value={certificate.heatTreatment || ''}
            onChange={(e) => setCertificate(prev => ({...prev, heatTreatment:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Nº Pedido de compra do cliente</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.purchaseOrderNumber || ''}
            onChange={(e) => setCertificate(prev => ({...prev, purchaseOrderNumber:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Usina de fabricação</S.Label>
          <Input 
            placeholder='Digite aqui'
            value={certificate.factory || ''}
            onChange={(e) => setCertificate(prev => ({...prev, factory:e.target.value}))}
          />
        </S.InputDiv>
        <SelectProductionOrderInCertificate
          certificate={certificate}
          setCertificate={setCertificate}
          itsOurs={itsOurs}
        />
        <div></div>
        <div></div>
        <div></div>
        <S.InputDiv>
          <S.Label>Observações</S.Label>
          <Textarea
            style={{ width: '100%' }}
            placeholder='Digite aqui'
            value={certificate.observations || ''}
            onChange={(e) => setCertificate(prev => ({...prev, observations:e.target.value}))}
          />
        </S.InputDiv>
      </S.HeaderFieldsContainer>
    </S.StructureContainer>
  )
}

export default HeaderFields